import React from "react"
import { Link } from "react-router-dom"
import cookieHelper from "helpers/getCookieData"
import moment from "moment"

const TrackingLink = ({ trackingNumber, sts = "" }) => (
  <a href={`/status/${trackingNumber}`} target="_blank" rel="noreferrer">
    {trackingNumber}{" "}
  </a>
)

export let ShipmentColumns = (handleEdit, handleDelete) => {
  return [
    {
      dataField: "actions",
      text: "",
      isDummyField: true,
      formatter: (cell, row) => (
        <>
          <Link
            to="#"
            className="btn btn-outline-secondary btn-sm edit"
            onClick={() => handleEdit(row.id)}
            title="Track or status"
          >
            <i className={`fas fa-map-signs`} />
          </Link>
        </>
      ),
    },
    {
      dataField: "actions2",
      text: "",
      isDummyField: true,
      formatter: (cell, row) => (
        <>
          <Link
            to="#"
            className="btn btn-danger btn-sm edit"
            onClick={() => handleDelete(row.id)}
            title="Delete AWB"
          >
            <i className={`fas fa-trash`} />
          </Link>
        </>
      ),
    },
    {
      dataField: "created_at",
      text: "Shipment Date",
      formatter: (cell, row) => {
        return moment(cell).format("DD-MM-YYYY")
      },
    },
    {
      dataField: "vs_tracking_number",
      text: "Tracking Number",
      formatter: (cell, row) => {
        return <TrackingLink trackingNumber={row.vs_tracking_number} />
      },
    },
    {
      dataField: "Courier Patner",
      text: "Courier Patner",
      formatter: (cell, row) => {
        return `${row.courier_partner.name}`
      },
    },
    {
      dataField: "live_tracking_number",
      text: "Live Tracking Number",
    },
    {
      dataField: "weight",
      text: "Weight",
    },
    {
      dataField: "_type",
      text: "Type",
    },
    {
      dataField: "price",
      text: "Price",
    },
    {
      dataField: "cod_amt",
      text: "COD Amt",
    },
    {
      dataField: "receivername",
      text: "Reciver Name",
    },
    {
      dataField: "receiverphone",
      text: "Reciver Phone",
    },
    {
      dataField: "sendername",
      text: "Sender Name",
    },
    {
      dataField: "senderphone",
      text: "Sender Phone",
    },
    {
      dataField: "receiveraddress",
      text: "To",
      formatter: (cell, row) => {
        return (
          row.receiveraddress +
          ", " +
          row.receivercity +
          ", " +
          row.receiverstate +
          ", " +
          row.receivercountry +
          ", " +
          row.receiverpincode
        )
      },
    },
    {
      dataField: "senderaddress",
      text: "From",
      formatter: (cell, row) => {
        return (
          row.senderaddress +
          ", " +
          row.sendercity +
          ", " +
          row.senderstate +
          ", " +
          row.sendercountry +
          ", " +
          row.senderpincode
        )
      },
    },
  ]
}

export let RoleColumns = [
  {
    dataField: "role_id",
    text: "#",
  },
  {
    dataField: "name",
    text: "role",
  },
  {
    dataField: "description",
    text: "Description",
    // }, {
    //     dataField: 'actions',
    //     text: "",
    //     isDummyField: true,
    //     formatter: (cell, row) => <>
    //         <Link to="#" className="btn btn-outline-secondary btn-sm edit" onClick={() => handleEdit(row.id)} title="Edit" ><i className={`fas fa-pencil-alt`} /></Link>
    //         {" "}
    //         <Link to="#" className={`btn btn-${row.status == 0 ? "danger" : "success"} btn-sm edit`} onClick={() => handleRemove(row.id, row.status == 1 ? 0 : 1, row.code)} title={row.status == 0 ? 'delete' : 'restore'} ><i className={`fas fas fa-trash-alt`} /></Link>
    //     </>
  },
]

export let BranchColumns = [
  {
    dataField: "branch_id",
    text: "#",
  },
  {
    dataField: "email",
    text: "Email",
  },
  {
    dataField: "contact_no",
    text: "Phone",
  },
  {
    dataField: "whatsp_app",
    text: "Whatsapp no",
  },
  {
    dataField: "city",
    text: "City",
    // }, {
    //     dataField: 'actions',
    //     text: "",
    //     isDummyField: true,
    //     formatter: (cell, row) => <>
    //         <Link to="#" className="btn btn-outline-secondary btn-sm edit" onClick={() => handleEdit(row.id)} title="Edit" ><i className={`fas fa-pencil-alt`} /></Link>
    //         {" "}
    //         <Link to="#" className={`btn btn-${row.status == 0 ? "danger" : "success"} btn-sm edit`} onClick={() => handleRemove(row.id, row.status == 1 ? 0 : 1, row.code)} title={row.status == 0 ? 'delete' : 'restore'} ><i className={`fas fas fa-trash-alt`} /></Link>
    //     </>
  },
]

export let EmployeeColumns = [
  {
    dataField: "id",
    text: "#",
  },
  {
    dataField: "name",
    text: "Employee Name",
  },
  {
    dataField: "contact_no",
    text: "Phone Number",
  },
  {
    dataField: "whatsp_app",
    text: "Whatsapp Number",

    // }, {
    //     dataField: 'code',
    //     text: 'Code'
    // }, {
    //     dataField: 'actions',
    //     text: "",
    //     isDummyField: true,
    //     formatter: (cell, row) => <>
    //         <Link to="#" className="btn btn-outline-secondary btn-sm edit" onClick={() => handleEdit(row.id)} title="Edit" ><i className={`fas fa-pencil-alt`} /></Link>
    //         {" "}
    //         <Link to="#" className={`btn btn-${row.status == 0 ? "danger" : "success"} btn-sm edit`} onClick={() => handleRemove(row.id, row.status == 1 ? 0 : 1, row.code)} title={row.status == 0 ? 'delete' : 'restore'} ><i className={`fas fas fa-trash-alt`} /></Link>
    //     </>
  },
]

export let CorierRateColumns = [
  {
    dataField: "location_id",
    text: "#",
  },
  {
    dataField: "pincode",
    text: "Pincode",
  },
  {
    dataField: "master_location.title",
    text: "District Name",
  },
  {
    dataField: "master_location.state.title",
    text: "State Name",
  },
]

export let ZoneColumns = [
  {
    dataField: "id",
    text: "#",
    formatter: (cell, row, rowIndex, formatExtraData) => rowIndex + 1,
  },
  {
    dataField: "title",
    text: "Zone Name",
  },
]

let MisReportsColumns = [
  {
    dataField: "id",
    text: "#",
    formatter: (cell, row, rowIndex, formatExtraData) => rowIndex + 1,
    csvFormatter: (cell, row, rowIndex, formatExtraData) => rowIndex + 1,
  },
  {
    dataField: "shipment_date",
    text: "P/U Date",
    formatter: (cell, row) =>
      row.shipment_date ? new Date(row.shipment_date).toLocaleDateString() : "",
    csvFormatter: (cell, row) =>
      row.shipment_date ? new Date(row.shipment_date).toLocaleDateString() : "",
  },
  {
    dataField: "ref_no",
    text: "Ref No#",
    formatter: (cell, row) => (row.ref_no ? row.ref_no : "-"),
    csvFormatter: (cell, row) => (row.ref_no ? row.ref_no : "-"),
  },
  {
    dataField: "shipping_name",
    text: "Courier",
    formatter: (cell, row) => (row.shipping_name ? row.shipping_name : "-"),
    csvFormatter: (cell, row) => (row.shipping_name ? row.shipping_name : "-"),
  },
  {
    dataField: "vs_tracking_number",
    text: "AWB Number",
    formatter: (cell, row) => {
      return <TrackingLink trackingNumber={row.vs_tracking_number} />
    },
    csvFormatter: (cell, row) => row.vs_tracking_number,
  },
  {
    dataField: "live_tracking_number",
    text: "Live Tracking Number",
  },
  {
    dataField: "is_rto",
    text: "RTO",
    formatter: (cell, row) => (row.is_rto ? "Yes" : "-"),
    csvFormatter: (cell, row) => (row.is_rto ? "Yes" : "-"),
  },
  {
    dataField: "mostRecentStatus",
    text: "Status",
    formatter: (cell, row) => (row.is_rto ? `Return - ${cell}` : cell),
    csvFormatter: (cell, row) => (row.is_rto ? `Return - ${cell}` : cell),
  },
  {
    dataField: "weight",
    text: "Weight",
  },
  {
    dataField: "_type",
    text: "Product Type",
    formatter: (cell, row) => (cell == "b2c" ? "Air" : "Surface"),
    csvFormatter: (cell, row) => (cell == "b2c" ? "Air" : "Surface"),
  },
  {
    dataField: "senderphone",
    text: "Senderphone",
  },
  {
    dataField: "sendercity",
    text: "Orginal City",
  },
  {
    dataField: "receivercity",
    text: "Destination City",
  },
  {
    dataField: "receiverpincode",
    text: "Destination Pincode",
  },
  {
    dataField: "receivername",
    text: "Consignee Name",
  },
  {
    dataField: "delivery_date",
    text: "Delivery Date",
    formatter: (cell, row) => {
      return row.delivery_date
        ? new Date(row.delivery_date).toLocaleDateString()
        : "-"
    },
    csvFormatter: (cell, row) => {
      return row.delivery_date
        ? new Date(row.delivery_date).toLocaleDateString()
        : "-"
    },
  },
  {
    dataField: "cod_type",
    text: "Cod Type",
    formatter: (cell, row) => (cell == "fix" ? "FIXED" : "Percentage"),
    csvFormatter: (cell, row) => (cell == "fix" ? "FIXED" : "Percentage"),
  },
  {
    dataField: "shipment_cost",
    text: "Shipment Cost",
    formatter: (cell, row) => {
      const price = parseFloat(row.price) || 0
      const codAmt = parseFloat(row.cod_amt) || 0
      return `${(price - codAmt).toFixed(2)}`
    },
    csvFormatter: (cell, row) => {
      const price = parseFloat(row.price) || 0
      const codAmt = parseFloat(row.cod_amt) || 0
      return `${(price - codAmt).toFixed(2)}`
    },
  },
  {
    dataField: "cod",
    text: "Order Value",
    formatter: cell => `${parseFloat(cell || 0).toFixed(2)}`,
    csvFormatter: cell => `${parseFloat(cell || 0).toFixed(2)}`,
  },
  {
    dataField: "cod_amt",
    text: "COD Value",
    formatter: cell => `${parseFloat(cell || 0).toFixed(2)}`,
  },
  {
    dataField: "price",
    text: "Price",
    formatter: cell => `${parseFloat(cell || 0).toFixed(2)}`,
  },
  {
    dataField: "logs",
    text: "Comment",
  },
]

const tokenData = cookieHelper.getCookie("_vslaccdt")
  ? JSON.parse(cookieHelper.getCookie("_vslaccdt"))
  : null

if (tokenData?.role == "client") {
  MisReportsColumns = [
    {
      dataField: "id",
      text: "#",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        const pageSize = 10 // Adjust this based on your table's page size
        return rowIndex + 1
      },
    },
    {
      dataField: "is_rto",
      text: "RTO",
      formatter: (cell, row) => (row.is_rto ? "Yes" : "-"),
      csvFormatter: (cell, row) => (row.is_rto ? "Yes" : "-"),
    },
    {
      dataField: "vs_tracking_number",
      text: "AWB Number",
      formatter: (cell, row) => {
        return <TrackingLink trackingNumber={row.vs_tracking_number} />
      },
      csvFormatter: (cell, row) => row.vs_tracking_number,
    },
    {
      dataField: "mostRecentStatus",
      text: "Status",
      formatter: (cell, row) => (row.is_rto ? `Return - ${cell}` : cell),
      csvFormatter: (cell, row) => (row.is_rto ? `Return - ${cell}` : cell),
    },
    {
      dataField: "ref_no",
      text: "Ref No#",
    },
    {
      dataField: "shipment_date",
      text: "P/U Date",
      formatter: (cell, row) => {
        return row.shipment_date
          ? new Date(row.shipment_date).toLocaleDateString()
          : "-"
      },
      csvFormatter: (cell, row) => {
        return row.shipment_date
          ? new Date(row.shipment_date).toLocaleDateString()
          : "-"
      },
    },
    {
      dataField: "sendercity",
      text: "Orginal City",
    },
    {
      dataField: "receivercity",
      text: "Destination City",
    },
    {
      dataField: "receiverpincode",
      text: "Destination City",
    },
    {
      dataField: "receivername",
      text: "Consignee Name",
    },
    {
      dataField: "delivery_date",
      text: "Delivery Date",
    },
    {
      dataField: "weight",
      text: "Weight",
    },
    {
      dataField: "_type",
      text: "Product Type",
      formatter: (cell, row) => (cell == "b2c" ? "Air" : "Surface"),
      csvFormatter: (cell, row) => (cell === "b2c" ? "Air" : "Surface"),
    },
    {
      dataField: "logs",
      text: "Comment",
    },
  ]
}

export { MisReportsColumns }
